import { takeEvery, put, call, select } from "redux-saga/effects";
import { defineMessages } from "react-intl";
import * as FollowUpsActions from "./followUpsActions";
import * as TaskActions from "./../task/taskActions";
import { makeApiCall, getTechnicianInfo } from "../helpers";
import taskServices from "./../../services/taskServices";
import { ALERT_TYPES, showAlert } from "./../alert/alertActions";
import { uploadAttachments } from "../attachments/attachmentsActions";
import { buildFollowUpUploadPayloads } from "./followUpsHelpers";
import _ from "lodash";
const messages = defineMessages({
    fetchFailed: {
        id: "alerts.follow-ups-sagas.fetch-failed",
        defaultMessage: "Unable to retrieve follow-up reasons: {responseError}",
        description: "Fetch follow up reasons failed",
    },
    saveSucceeded: {
        id: "alerts.follow-ups-sagas.save-succeeded",
        defaultMessage: "Save follow-ups succeeded",
        description: "Save follow ups succeeded alert message",
    },
    saveFailed: {
        id: "alerts.follow-ups-sagas.save-failed",
        defaultMessage: "Save follow-ups failed",
        description: "Save follow ups failed alert message",
    },
});
export const watchFollowUpsRequests = function* () {
    yield takeEvery(FollowUpsActions.REQUEST_FOLLOW_UP_REASONS, fetchFollowUpReasons);
    yield takeEvery(FollowUpsActions.SAVE_FOLLOW_UPS_INFO, saveFollowUps);
    yield takeEvery(FollowUpsActions.UPDATE_FOLLOW_UPS_INFO_SUCCEEDED, updateFollowUpResponse);
    yield takeEvery(FollowUpsActions.REQUEST_FOLLOW_UP_DUE_DATE, getFollowUpDewDate);
};
export const fetchFollowUpReasons = function* (action) {
    try {
        let followUpReasons = yield call(makeApiCall, taskServices.getFollowUpReasons) || [];
        yield put(FollowUpsActions.requestFollowUpReasonsSucceeded(followUpReasons));
    } catch (responseError) {
        yield put(showAlert(Date.now(), messages.fetchFailed, ALERT_TYPES.error, { responseError: responseError.body }));
        yield put(FollowUpsActions.requestFollowUpReasonsFailed());
    }
};
export const getFollowUpDewDate = function* (action) {
    try {
        let dueDate = yield call(makeApiCall, taskServices.getFollowUpDewDate, {
            workOrderNumber: action.workorderNumber,
            reasonCode: 36,
        });
        yield put(FollowUpsActions.getFollowUpDewDateSucceeded(dueDate));
    } catch (responseError) {
        yield put(showAlert(Date.now(), messages.fetchFailed, ALERT_TYPES.error, { responseError: responseError.body }));
        //yield put(FollowUpsActions.requestFollowUpReasonsFailed())
    }
};
export const updateFollowUpResponse = function* (action) {
    try {
        //yield put(FollowUpsActions.updateFollowUpResponse(action?.followUpResponse));
    } catch (responseError) {
        yield put(FollowUpsActions.updateFollowUpResponseFailed());
    }
};
export const saveFollowUps = function* (action) {
    const activityQuestionsUuids = yield select((state) => state.activityQuestions?.questions);
    try {
        let ACUTmessage = [];
        const technicianInfo = yield select(getTechnicianInfo);
        const followUpsRequestForValidatedDoubles = action?.followUpsRequest?.body?.validatedForDoubles ?? false;
        const followUpsResponse = yield call(makeApiCall, taskServices.saveFollowUps, {
            ...action.followUpsRequest,
            workOrderNumber: action.workOrderNumber,
            userName: technicianInfo.userName,
        });
        if (followUpsResponse && followUpsResponse.body && !followUpsResponse.body.errorMessages) {
            yield put(FollowUpsActions.saveFollowUpsSucceeded(followUpsResponse));
            if (followUpsRequestForValidatedDoubles) yield put(showAlert(Date.now(), messages.saveSucceeded, ALERT_TYPES.success));
            if (followUpsResponse.body.createdFollowUpList != null) {
                followUpsResponse.body.createdFollowUpList.map((res) => {
                    if (res?.followUpTpyeId?.action == "ACUT TICKET" && res?.message != "") {
                        ACUTmessage.push(res.message);
                    }
                });
            }
            if (followUpsResponse.body.updatedFollowUpList != null) {
                followUpsResponse.body.updatedFollowUpList.map((res) => {
                    if (res?.followUpTpyeId?.action == "ACUT TICKET" && res?.message != "") {
                        ACUTmessage.push(res.message);
                    }
                });
            }
            if (followUpsResponse.body.deletedFollowUpList != null) {
                followUpsResponse.body.deletedFollowUpList.map((res) => {
                    if (res?.followUpTpyeId?.action == "ACUT TICKET" && res?.message != "") {
                        ACUTmessage.push(res.message);
                    }
                });
            }
            let DisplayAlert = ACUTmessage.filter((msg) => msg);
            if (DisplayAlert.length > 0) {
                alert(DisplayAlert);
                ACUTmessage = [];
            }

            if (!followUpsRequestForValidatedDoubles && followUpsResponse?.body?.createdFollowUpList?.length) {
                const userName = yield select((state) => state.login.keycloak.profile.username);
                const uploadPayloads = buildFollowUpUploadPayloads(followUpsResponse?.body?.createdFollowUpList, activityQuestionsUuids, userName);
                for (const { filesPayload, followUpId } of uploadPayloads) {
                    yield put(uploadAttachments(filesPayload, followUpId));
                }
            }
        } else {
            yield put(showAlert(Date.now(), messages.saveFailed, ALERT_TYPES.error, followUpsResponse));
            yield put(FollowUpsActions.saveFollowUpsFailed());
        }
        if (
            !followUpsResponse?.body?.errorMessages &&
            action?.payload?.isPopupOpen &&
            followUpsResponse?.body?.createdFollowUpList[0]?.duplicateWorkOrdersDTO?.duplicateWorkOrderDTOList?.length > 0
        ) {
            yield put(FollowUpsActions.duplicateCheckPopup(true));
        }

        // refresh the updated task
        if (action?.refresh) {
            yield put(TaskActions.fetchWorkorder(action.workOrderNumber, true));
            if (!followUpsResponse?.body?.errorMessages && action?.payload?.isFlag) {
                yield put(TaskActions.requestToAddFollowup(false));
                yield put(
                    TaskActions.taskComplete({
                        workOrderNumber: action.workOrderNumber,
                        userName: action.payload.userName,
                        completionCode: action.payload.completionCode,
                    }),
                );
            }
            if (
                !followUpsResponse?.body?.errorMessages &&
                action?.payload?.popupOpen &&
                followUpsResponse?.body?.createdFollowUpList[0]?.duplicateWorkOrdersDTO.duplicateWorkOrderDTOList?.length === 0
            ) {
                const followUpList = action.followUpsRequest.followUpList[0];
                const filteredData = [
                    {
                        ...followUpList,
                        validatedForDoubles: true,
                        duplicateWorkOrdersDTO: null,
                    },
                ];
                yield put(FollowUpsActions.duplicateWorkOrders(filteredData));
                yield put(FollowUpsActions.noDuplicatesCheck(true));
            }
            if (
                !followUpsResponse?.body?.errorMessages &&
                action?.payload?.popupOpen &&
                followUpsResponse?.body?.createdFollowUpList[0]?.duplicateWorkOrdersDTO?.duplicateWorkOrderDTOList?.length > 0
            ) {
                yield put(FollowUpsActions.duplicateCheckPopup(true));
                const followUpList = action.followUpsRequest.followUpList[0];
                const filteredData = [
                    {
                        ...followUpList,
                        validatedForDoubles: true,
                        duplicateWorkOrdersDTO: {
                            duplicateWorkOrderDTOList:
                                followUpsResponse?.body?.createdFollowUpList[0]?.duplicateWorkOrdersDTO?.duplicateWorkOrderDTOList,
                        },
                    },
                ];
                yield put(FollowUpsActions.duplicateWorkOrders(filteredData));
            }
            try {
                let followUpReasons = yield call(makeApiCall, taskServices.getFollowUpReasons) || [];
                yield put(FollowUpsActions.requestFollowUpReasonsSucceeded(followUpReasons));
            } catch (responseError) {
                yield put(showAlert(Date.now(), messages.fetchFailed, ALERT_TYPES.error, { responseError: responseError.body }));
                yield put(FollowUpsActions.requestFollowUpReasonsFailed());
            }
        }
    } catch (responseError) {
        yield put(showAlert(Date.now(), messages.saveFailed, ALERT_TYPES.error, { responseError: responseError.body }));
        yield put(FollowUpsActions.saveFollowUpsFailed());
    }
};
